import React, { useMemo } from "react";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { KYC_REJECTED as T } from "../../config/zinihubConfig";
import styles from "./KYCRejected.module.css";

const KYCRejected = () => {
  const { token, decodeToken } = useAuth();
  const decodedToken = useMemo(() => decodeToken(token), [token, decodeToken]);

  if (!decodedToken) {
    return (
      <div className={styles.loadingWrap}>
        <Spin size="large" />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageTitle}>{T.PAGE_TITLE}</div>

      <div className={styles.statusCard}>
        <div className={styles.statusHeader}>
          <div className={styles.statusIconWrap}>
            <span>{T.STATUS_ICON}</span>
          </div>
          <div className={styles.statusInfo}>
            <div className={styles.statusTitle}>{T.STATUS_TITLE}</div>
            <div className={styles.statusDate}>{T.REVIEWED_ON}</div>
          </div>
          <span className={styles.statusBadge}>{T.BADGE}</span>
        </div>
        <div className={styles.statusInfoBox}>{T.INFO_TEXT}</div>
      </div>

      <div className={styles.issuesCard}>
        <div className={styles.issuesTitle}>{T.ISSUES_TITLE}</div>
        {T.ISSUES.map(({ icon, title, reason, flagged }) => (
          <div
            key={title}
            className={`${styles.issueRow} ${flagged ? styles.issueRowFlagged : styles.issueRowOk}`}
          >
            <span className={styles.issueIcon}>{icon}</span>
            <div className={styles.issueContent}>
              <div className={`${styles.issueTitle} ${flagged ? styles.issueTitleFlagged : styles.issueTitleOk}`}>
                {title}
              </div>
              <div className={`${styles.issueReason} ${flagged ? styles.issueReasonFlagged : styles.issueReasonOk}`}>
                {reason}
              </div>
            </div>
            <span className={styles.issueFlag}>{flagged ? "\u26a0\ufe0f" : "\u2713"}</span>
          </div>
        ))}
      </div>

      <button className={styles.reuploadBtn} type="button">
        {T.REUPLOAD_BTN}
      </button>

      <div className={styles.footer}>
        {T.NEED_HELP} <span className={styles.supportLink}>{T.CONTACT_SUPPORT}</span>
      </div>
    </div>
  );
};

export default KYCRejected;
